<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <CreateOperatorFromTemplate v-if="isAdmin" ref="templateModal" @finish="handleItemsUpdate" />
    <OperatorTemplateOperations v-if="isAdmin" ref="templateOperations" @finish="handleItemsUpdate" />

    <section class="content">
      <div class="container-fluid">
        <div class="row col-lg-12">
          <div class="form-group col-sm-4">
            <!-- <EditForm :defaultValues="{ settings: {}, urls: {} }" create title="Create back operator"
              @finish="handleItemsUpdate">
              <template #button="{ onclick }">
                <b-button type="button" variant="success" @click="onclick"><i class="fas fa-plus"></i> Create</b-button>
              </template>
</EditForm> -->
          </div>
        </div>

        <b-row class="col-lg-12">
          <div class="col-lg-3 col-md-3 col-sm-12" v-for="({ id, label }) in filterInputs" v-bind:key="id">
            <b-form-group label-cols-lg="3" :label-for="id + '-filter-input'" :label="label">
              <b-form-input :id="id + '-filter-input'" v-model="filters[id]" autocomplete="off"
                :placeholder="'Enter ' + label" />
            </b-form-group>
          </div>
        </b-row>

        <b-row class="col-lg-12">
          <div class="col-lg-12 col-md-12 col-sm-12 apply-clear">
            <FilterButtons :cancel="this.cancel" :loadFn="loadItems" :cancelFn="cancelRequest"
              :resetFn="clearFilters" />
          </div>
        </b-row>
        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="table-wrapper mb-10">
                <b-table :striped="true" :small="true" :hover="true" :empty-text="emptyText" show-empty :busy="!!cancel"
                  :items="items" :fields="fields" :sort-by="sortBy" :sort-desc="sortDesc" :no-local-sorting="true"
                  :sort-icon-left="true" @sort-changed="sortingChanged">
                  <template #cell(logo)="row">
                    <div style="max-width: 200px" class="mb-2" v-if="row.item.settings && row.item.settings.logo">
                      <b-img :src="backUrl + '/' + row.item.settings.logo + '?t=' + Date.now()" fluid alt="Logo"
                        class="partner-logo"></b-img>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <b-button v-if="isAdmin" variant="outline-primary" class="mr-1" size="xs"
                      v-b-tooltip.hover title="Create operator from this template" aria-label="Create operator from this template"
                      @click="openTemplate(row.item.id)">
                      <i class="fas fa-copy" aria-hidden="true"></i>
                    </b-button>
                    <EditForm :defaultValues="{ ...row.item }" title="Edit back operator" @finish="handleItemsUpdate" @create-template="openTemplate" />
                    <RemoveForm :object="row.item.name" message="Please confirm removing back operator"
                      :url="'/api/v1/engine-operators/' + row.item.id" @finish="handleItemsUpdate" />
                  </template>
                </b-table>
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <b-pagination class="float-right" v-model="pagination.page" :total-rows="pagination.records"
                  :per-page="pagination.onPage" @change="onPageChange" first-number last-number />
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <ve-pagination class="float-right" :page-index="pagination.page" :page-size="pagination.onPage"
                  :total="pagination.records" :pagingCount="pagination.count" :layout="['total', 'sizer']"
                  :pageSizeOption="pagination.pageSizeOption" @on-page-size-change="onPageSizeChange" />
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
import EditEngineOperatorForm from "../../components/EngineOperators/EditEngineOperatorForm.vue";
import RemoveForm from "../../components/remove-form/RemoveForm.vue";
import axios from "axios";
import { getRouteIcon, ROUTE_AGGR_CONFIGS } from "../../utils/routerIcons";
import FilterButtons from "../../components/FilterButtons";
import CreateOperatorFromTemplate from "../../components/Operators/CreateOperatorFromTemplate.vue";
import OperatorTemplateOperations from "../../components/Operators/OperatorTemplateOperations.vue";
import * as Roles from "../../definitions/Roles";

function getDefaultPagination() {
  return {
    onPage: 10,
    page: 1,
    records: 0,
    count: 5,
    pageSizeOption: [10, 25, 50, 100, 200],
  };
}

function getDefaultSort() {
  return {
    column: 'id',
    order: 'ASC',
  };
}

function jsonFormatter(value) {
  const txt = JSON.stringify(value);

  return txt.length <= 23 ? txt : `${txt.substr(0, 20)}...`;
}

export default {
  components: {
    EditForm: EditEngineOperatorForm,
    RemoveForm,
    FilterButtons,
    CreateOperatorFromTemplate,
    OperatorTemplateOperations,
  },
  data() {
    return {
      cancel: null,
      error: null,
      items: [],
      sorts: getDefaultSort(),
      filters: {},
      sortBy: null,
      sortDesc: null,
      pagination: getDefaultPagination(),
      filterInputs: [
        { label: 'Name', id: 'name' },
        { label: 'Secret', id: 'secret' },
      ],
    }
  },
  computed: {
    isAdmin() {
      const user = this.$store.getters.currentUser;
      return user && user.type === Roles.ADMIN;
    },
    fields() {
      if (this.$store.getters['isShowDebugTools']) {
        return [
          { key: 'id', label: '_ID', sortable: true },
          { key: 'secret', label: 'Secret', sortable: true },
          { key: 'name', label: 'Name', sortable: true },
          { key: 'settings', label: 'Settings', formatter: jsonFormatter },
          { key: 'urls', label: 'Urls', formatter: jsonFormatter },
          { key: 'logo', label: 'Logo' },
          { key: 'actions', label: 'Actions' }
        ];
      }

      return [
        { key: 'id', label: '_ID', sortable: true },
        { key: 'secret', label: 'Secret', sortable: true },
        { key: 'name', label: 'Name', sortable: true },
        { key: 'settings', label: 'Settings', formatter: jsonFormatter },
        { key: 'urls', label: 'Urls', formatter: jsonFormatter },
        { key: 'actions', label: 'Actions' }
      ];
    },
    backUrl() {
      return process.env.VUE_APP_BACK_URL;
    },
    emptyText() {
      if (this.cancel) {
        return 'Loading items..';
      }

      if (this.error) {
        return this.error;
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_AGGR_CONFIGS),
  },
  methods: {
    openTemplate(sourceId) {
      if (this.isAdmin) this.$refs.templateModal.show(sourceId, 'engine-operators');
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.pagination.page = 1;

      this.loadItems();
    },
    handleItemsUpdate() {
      this.loadItems();
    },
    clearFilters() {
      this.filters = {};
      this.sortingChanged({
        sortBy: getDefaultSort().column,
        sortDesc: getDefaultSort().order === 'DESC'
      })
    },
    loadItems() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });

      this.items = [];

      let self = this;
      loadingInstance.show();

      this
        .$http({
          url: '/api/v1/engine-operators',
          params: {
            ...this.filters,
            // pagination
            limit: this.pagination.onPage,
            offset: this.pagination.onPage * (this.pagination.page - 1),

            // sort params
            orderBy: this.sortBy,
            direction: this.sortDesc ? 'DESC' : 'ASC',
          },
          method: 'GET',
          cancelToken: new axios.CancelToken(c => { self.cancel = c })
        })
        .then(resp => {
          let { items, pagination: { limit, totalCount } } = resp.data;

          this.items = items;
          this.pagination.onPage = limit;
          this.pagination.records = totalCount;
        })
        .catch((err) => {
          this.items = [];
          this.error = err;
        })
        .finally(() => {
          loadingInstance.close();
          this.cancel = null;
        });
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request');
      }
    },
    onPageChange(page) {
      this.pagination.page = page;
      this.loadItems()
    },
    onPageSizeChange(pageSize) {
      this.pagination.page = 1;
      this.pagination.onPage = pageSize;
      this.loadItems();
    },
  },
  async beforeMount() {
    await this.$store.dispatch("tablesForSelect/loadList");
  },
  mounted() {
    this.loadItems();
  }
}
</script>

<style>
.partner-logo {
  border: 1px solid #555;
  border-radius: 4px;

}
</style>
